import { useLayoutEffect, useState } from "react";
import { useJwt } from "../../../biz/hooks/data/useFetcher";
import { Config } from "../../../biz/data/Config";
import { PortalContainer } from "./Portal";
import { NullableString } from "../../../biz/data/Types";

type ImageFormats = "hd" | "thumb";
const defaultPlantImage = "/gfx/plant_list_404.png";
export const JwtImage = ({ imageId, plantImage, format = "hd", openOnClick = false, containerClassName, imageClassName, title = "" }:
    { imageId: string, plantImage: boolean, format: ImageFormats, openOnClick?: boolean, imageText?: string, containerClassName?: string, imageClassName?: string, previewImageClassName?: string, title?: string }) => {
    const ui = useJwtImage(imageId, format, plantImage);
    return (
        <>
            <div className={"generic-image-container" + (openOnClick ? " cursor-pointer" : "") + (containerClassName ? " " + containerClassName : "")}>
                <img
                    id={imageId}
                    src={ui.imgSrc ?? ""}
                    className={"img " + (imageClassName ? imageClassName : "")}
                    data-imageid={imageId}
                    title={title}
                    loading="lazy"
                />
            </div>
        </>
    )
}

export const ImageUrlBuilder = (imageId: string, format: ImageFormats = "hd", plantImage?: boolean) => {
    if (plantImage === true) {
        if (Config.isDev) {
            return "https://localhost:44318/plant/" + format + "/" + imageId;
        } else {
            return "https://images.ohgarden.se/plant/" + format + "/" + imageId;
        }
    } else {
        if (Config.isDev) {
            return "https://localhost:44318/" + format + "/" + imageId;
        } else {
            return "https://images.ohgarden.se/" + format + "/" + imageId;
        }
    }
}

const useJwtImage = (imageId: string, format: ImageFormats = "hd", plantImage: boolean) => {
    const [imgSrc, setImgSrc] = useState<string>(defaultPlantImage);
    const getUrl = () => {
        if (plantImage) {
            if (Config.isDev) {
                return "https://localhost:44318/plant/" + format + "/" + imageId;
            } else {
                return "https://images.ohgarden.se/plant/" + format + "/" + imageId;
            }
        } else {
            if (Config.isDev) {
                return "https://localhost:44318/" + format + "/" + imageId;
            } else {
                return "https://images.ohgarden.se/" + format + "/" + imageId;
            }
        }
    }
    var url = getUrl();

    const jwtops = useJwt();

    const doit = async () => {

        if (imageId) {
            const jwt = await jwtops.getJwt();

            fetch(url, { method: "GET", headers: { Authorization: 'Bearer ' + jwt } })
                .then(async (response) => {
                    if (response.ok) {
                        return { success: true, blob: await response.blob() };
                    } else {
                        return { success: false, reason: 404 };
                    }
                })
                .then((data) => {
                    if (data.success) {
                        setImgSrc(URL.createObjectURL(data.blob as Blob));
                    } else {
                        setImgSrc(defaultPlantImage);
                    }
                })
                .catch(error => console.log('error is', error));;
        } else {
            setImgSrc(defaultPlantImage);
        }
    }

    useLayoutEffect(() => {
        doit();
    }, [, imageId]);

    return {
        imgSrc: imgSrc
    }
}


export const PlantImageOverlay = ({ plantImageid, onClick }: { plantImageid: NullableString, onClick(): void }) => {
    return (
        <PortalContainer visible={!!plantImageid} clickOutside={() => {
            if (!!onClick) {
                onClick()
            }
        }}>
            <div onClick={onClick}>
                <JwtImage imageId={plantImageid ?? ""} plantImage={true} format={"hd"} />
            </div>
        </PortalContainer>
    )
}
